import { parseAsString, parseAsStringEnum, useQueryStates } from 'nuqs'

import { PANEL_STATUS_FILTER } from '@/lib/constants'
import { PanelStatus } from '@/types/misc'

export function useProfessionalNetworkFilters() {
  return useQueryStates({
    companyName: parseAsString.withDefault(''),
    // A location filter value, e.g. "country:FR", for partner firms based or
    // working there; '' for all locations
    location: parseAsString.withDefault(''),
    panelStatus: parseAsStringEnum<PanelStatusFilter>(
      Object.values(PANEL_STATUS_FILTER),
    ).withDefault(DEFAULT_RELATIONSHIP_STATUS_FILTER),
  })
}

export const DEFAULT_RELATIONSHIP_STATUS_FILTER =
  PANEL_STATUS_FILTER.approvedOrRequested

export type PanelStatusFilter = PanelStatus | 'all' | 'approvedOrRequested'
